import React from 'react';
import { Bounce, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { isRtlLocale } from '../../i18n/constants';

export default function ToastContainerRtl() {
  const { i18n } = useTranslation();
  const rtl = isRtlLocale(i18n.language);

  return (
    <ToastContainer
      position={rtl ? 'top-left' : 'top-right'}
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={rtl}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Bounce}
    />
  );
}
